import { createStore, useStore as baseUseStore, createLogger, Store } from "vuex";
import { App, InjectionKey } from "vue";
import modules from "@/store/modules";
import { IStore } from "./types";

export const key: InjectionKey<Store<IStore>> = Symbol();

// const debug = process.env.NODE_ENV !== "production";
const debug = false;
const plugins = debug
  ? [
      createLogger({
        filter(mutation, stateBefore, stateAfter) {
          const notNeedDebugs: string[] = ["lockscreen/setLockTime", "lockscreen/setLock"];
          return !notNeedDebugs.includes(mutation.type);
        },
      }),
    ]
  : [];

const store = createStore<IStore>({
  plugins,
  modules,
});

export function useStore() {
  return baseUseStore(key);
}

export function setupStore(app: App) {
  app.use(store, key);
  app.directive("perm", {
    mounted(el, binding, vnode) {
      if (binding.value && binding.value.length > 0) {
        if (!store.state.user.buttons[binding.value]) {
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          } else {
            el.remove();
          }
        }
      }
    },
  });
}

export default store;
